import {h, render} from 'preact';
import App from './containers/SmsPortal';
import Provider from 'preact-context-provider';
import {client} from '@core/GraphQLProvider';

document.addEventListener( 'DOMContentLoaded', () => {
    const container = document.querySelector( '#equipment-repair-container' );

    if ( container ) {
        render(
            <Provider client={client}>
                <App/>
            </Provider>,
            null,
            container
        );
    }
} );
